export default {
  RoleChange: 'role-change'
}
